import { Badge, Checkbox, FormField, KeyValuePairs, Link, Modal, SplitPanel, Table, TextFilter, Toggle } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useMemo, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, getUser, getUserType, setData, setLoading } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiAllInclusiveBox } from '@mdi/js';
import Icon from '@mdi/react';
import Favorites from '../../../../../components/extras/Favorites';

import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';

const pageSize = 20;

export const AdminMovementsInstallmentsPage = () => {
    //const storeAdmin = useStoreAdmin();
    const { data, menu, parameters } = useGlobalState();
    const [installments, setInstallments] = useState<ItemInstallments[]>([]);
    const [users, setUsers] = useState<any[]>();
    const [filteringText, setFilteringText] = useState("");
    const [isActiveMovementRecurring, setIsActiveMovementRecurring] = useState(1);


    type ItemInstallments = {
        idMovementRecurring: number,
        idAccountPlan: number,
        installments: number,
        installmentsExecuted: number,
        amount: number,
        currency: string,
        recurringDateCreated: string,
        recurringDateLastExecuted: string,
        data: string,
        isActiveMovementRecurring: number,
        accountPlan: string,
        users: [],
        day: number
    }


    useEffect(() => {
        handleRefreshMovements();
    }, [isActiveMovementRecurring]);


    const filtered = useMemo(() => {
        //if (!filterAccountsPlans.trim()) return accountPlans;
        let filter = users ?? [];
        if (filteringText.trim()) {
            const terms = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
            filter =
                users.filter(item => {
                    const haystack = [
                        item.displayName ?? "",
                        item.userType ?? "",
                        item.idUser.toString(),
                    ].join(" ").toLowerCase();

                    return terms.every(term => haystack.includes(term));
                })

        }

        return filter;
    }, [filteringText, users]);

    const handleActiveInstallment = async (idMovementRecurring: number, checked: boolean) => {
        try {
            setLoading(true)
            console.log(idMovementRecurring)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/installments/isactive',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idMovementRecurring: idMovementRecurring, isActiveMovementRecurring: checked ? 1 : 0 }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                handleRefreshMovements();
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, 'error', setData);
            setLoading(false)
        } finally { }

    }
    const handleRefreshMovements = async () => {


        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/installments/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ isActiveMovementRecurring: isActiveMovementRecurring }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setInstallments(data.installments);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }



    return (
        <CustomAppLayout
            toolsHide

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />}
                            description={<Checkbox checked={isActiveMovementRecurring === 1}
                                onChange={(e) => {
                                    setIsActiveMovementRecurring(e.detail.checked ? 1 : -1)
                                }}
                            >Mostrar solo activos</Checkbox>}
                        >
                            Cuotas programadas
                        </Header>


                        <Table
                            variant="embedded"
                            columnDefinitions={[
                                {
                                    id: "data",
                                    header: "Glosa",
                                    cell: item => (
                                        <FormField
                                            description={item?.accountPlan || ""}
                                            label={
                                                <>
                                                    {item.data}
                                                    {item.isActiveMovementRecurring === 0 && (
                                                        <span style={{ marginLeft: "4px" }}>
                                                            <Badge color="red">Inactivo</Badge>
                                                        </span>
                                                    )}
                                                </>
                                            }
                                        />
                                    )
                                },
                                {
                                    id: "ammount",
                                    header: "Monto",
                                    cell: item =>
                                    (item.currency === "CLP" ?
                                        item.amount.toLocaleString('es-CL', {
                                            style: 'currency',
                                            currency: 'CLP',
                                            maximumFractionDigits: 0
                                        }) :
                                        `UF ${item.amount.toLocaleString('es-CL', {
                                            style: 'currency',
                                            currency: 'CLP',
                                            maximumFractionDigits: 4
                                        })}`
                                    )

                                },
                                {
                                    id: "installments",
                                    header: "Cuotas",
                                    cell: item => (
                                        <>
                                            {item.installmentsExecuted}/
                                            {item.installments > 0 ? item.installments : <Icon path={mdiAllInclusiveBox} size={1} />}
                                        </>
                                    )
                                },
                                {
                                    id: "users",
                                    header: "Usuarios",
                                    cell: item => (
                                        <Link onClick={() => {
                                            setUsers(item.users.map((user: any) => {
                                                const fullUser = getUser(user.idUser, data);
                                                const userTypeObj = getUserType(fullUser?.idUserType, data);

                                                return {
                                                    idUser: user.idUser,
                                                    displayName: fullUser?.displayName ?? "",
                                                    userType: userTypeObj?.userType ?? ""
                                                };
                                            }));
                                        }}>
                                            <Badge color='blue'>{item.users.length}</Badge>
                                        </Link>
                                    )

                                },
                                {
                                    id: "day",
                                    header: "Día del mes",
                                    cell: item => item.day

                                },
                                {
                                    id: "active",
                                    header: "Activo",
                                    cell: item => (
                                        <Toggle
                                            checked={item.isActiveMovementRecurring === 1}
                                            onChange={({ detail }) => {
                                                console.log(item)
                                                handleActiveInstallment(item.idMovementRecurring, detail.checked)
                                                //const newValue = detail.checked ? 1 : 0;
                                                // update item or state here
                                                //item.isActiveMovementRecurring = newValue;
                                                // or, if this comes from React state, call your state updater instead:
                                                // updateInstallments(prev => prev.map(x => x.idMovementRecurring === item.idMovementRecurring ? { ...x, isActiveMovementRecurring: newValue } : x));
                                            }}
                                        />
                                    )
                                }
                            ]}
                            trackBy="idMovementRecurring"
                            items={installments ?? []}
                            empty={
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="inherit"
                                >
                                    <SpaceBetween size="m">
                                        <b>Sin cuotas recurrentes</b>
                                    </SpaceBetween>
                                </Box>
                            }
                        />
                        {!!filtered && filtered.length > 0 && (
                            <Modal visible={!!users} onDismiss={() => setUsers([])} closeAriaLabel="Close modal" header="Usuarios asociados a la cuota">
                                <Table
                                    variant='embedded'
                                    stickyHeader
                                    filter={
                                        <TextFilter
                                            filteringPlaceholder="Buscar usuario"
                                            filteringText={filteringText}
                                            onChange={(e) => { setFilteringText(e.detail.filteringText); }}
                                        />
                                    }
                                    columnDefinitions={[
                                        {
                                            id: "idUser",
                                            header: "ID",
                                            cell: item => item.idUser
                                        },
                                        {
                                            id: "user",
                                            header: "Usuario",
                                            cell: item => item.displayName
                                        },
                                        {
                                            id: "userType",
                                            header: "Tipo",
                                            cell: item => item.userType
                                        },
                                    ]}
                                    items={filtered ?? []}
                                />

                            </Modal>
                        )}
                    </SpaceBetween>
                </>
            }
        />
    );
};
